import type { IconData } from '@stacksjs/iconify-core'

export const iHealthServices: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M21.822 62.675h20.424V42.248h20.429V21.809H42.246V1.383H21.822v20.426H1.388v20.439h20.434z\"/>",
  "width": 64,
  "height": 64,
  "viewBox": "0 0 64 64"
}

export default iHealthServices
